import React, { useEffect, useRef, useState } from "react";
import {
  Col,
  Container,
  Form,
  InputGroup,
  Overlay,
  Row,
  Spinner,
  Tab,
  Table,
  Tooltip,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import toprightimg from "../assets/images/marketplace-top-right.png";
import activestatus from "../assets/images/activeStatus.svg";
import pendingstatus from "../assets/images/pendingStatus.svg";
import inprocessstatus from "../assets/images/inProcessStatus.svg";
import reviewIcon from "../assets/images/reviewIcon.svg";
import { API_URL } from "../services/APIRoute";
import { apiCall } from "../services/AxiosService";
import { apiResponse } from "../services/APIResponse";
import { commonservices } from "../services/CommonServices";
import Skeleton from "react-loading-skeleton";
import Nodata from "./common-component/Nodata";
import profilepic from "../assets/images/dummy-profile-pic.jpg";
import Loader, { LoaderType } from "./common-component/Loader";
import { useDispatch, useSelector } from "react-redux";
import TakeOverReviewModal from "../Modals/TakeOverReviewModal";
import searchicon from "../assets/images/searchicon.svg";
import CategoryListTab from "../Modals/CategoryListTab";
import useDebounce from "../hooks/useDebounce";
import { CategoryGetList } from "../services/ReduxTookit/Slice/CategoryRedux";
import { MachineGetList } from "../services/ReduxTookit/Slice/MachineRedux";

function MachineReviewListing() {
  const dispatch = useDispatch();
  let Userdata = useSelector((state) => state?.userinfo?.UserInfo);
  const navigate = useNavigate();
  const [machineList, setMachineList] = useState([]);
  
  const [activeTab, setActiveTab] = useState(0);
  // const [categoryList, setCategoryList] = useState([]);
  const [LoadingCategory, setLoadingCategory] = useState(false);
  const [reviewMachineLoader, setReviewMachineLoader] = useState(false);
  const [allMachineList, setAllMachineList] = useState(false);
  const [showTakeOverModal, setShowTakeOverModal] = useState(false);
  const takeOverModalRef = useRef();
  const [showOthersTab, setShowOthersTab] = useState(false);
  const othersTabRef = useRef();
  const [activeStatus, setActiveStatus] = useState("Total Machines");
  const [newStateManage, setNewStateManage] = useState({
    page: 1,
    catagory: "",
    status: "",
    search: "",
  });
  const tableRef = useRef(null);
  const [isApiCalled, setIsApiCalled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [CategoryID, setCategoryID] = useState("");
  const [categoryApiLoader, setCategoryApiLoader] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const debouncingValue = useDebounce(searchTerm, 500);
  const firstTimeApiCalledRef = useRef(false);
  const [totalRecord, setTotalRecord] = useState(1);

  const GetCategoryData = useSelector(
    (state) => state?.categoryredux?.CategoryGetList?.data
  );
  let categoryList = [];
  if (GetCategoryData?.isValidate) {
    let filterData = GetCategoryData?.data?.data?.filter(
      (x) => x?.refcategoryid === 0
    );
    categoryList = [{ categoryid: "", categoryname: "All" }, ...filterData];
  }

  const handleOverlay = (e) => {
    let element = document.getElementById(e?.currentTarget?.id);
    if (element) {
      if (element.classList.contains("overlay-isopen")) {
        element.classList.remove("overlay-isopen");
      } else {
        element.classList.add("overlay-isopen");
      }
    }
  };

  const handleshowMenu = (e) => {
    if (document.getElementById("body").classList.contains("popup-is-open")) {
      document.getElementById("body").classList.remove("popup-is-open");
      handleOverlay(e);
    } else {
      document.getElementById("body").classList.add("popup-is-open");
    }
    setShowOthersTab(!showOthersTab);
  };

  const getCategoryList = async () => {
    setLoadingCategory(true);
    let body = {
      categoryname: "",
      subscriberid: "",
    };
    try {
      dispatch(CategoryGetList(body)).then(() => {
        setLoadingCategory(false);
      });
    } catch (error) {
      setLoadingCategory(false);
    }
  };

  const getMachineList = async (categoryID) => {
    if (loading || isSearching) return;
    if (newStateManage?.page === 1) {
      setReviewMachineLoader(true);
      setCategoryApiLoader(true);
      setIsSearching(true);
    } else {
      setLoading(true);
    }
    const currentCategoryID = categoryID || newStateManage?.catagory;

    const table = document.querySelector(
      "#ReviwerTableContainer .table-responsive"
    );

    if (table) {
      table.removeEventListener("scroll", handleScroll);
    }

    const body = {
      machinename: debouncingValue,
      // categoryids: newStateManage?.catagory ,
      categoryids: currentCategoryID,
      status:
        newStateManage?.status === "Total Machines"
          ? ""
          : newStateManage?.status === "Approved"
          ? "Publish"
          : newStateManage?.status,
      pagenumber: newStateManage?.page,
      pagesize: process.env.REACT_APP_MACHINE_TABLE_PAGE_SIZE,
    };

    dispatch(MachineGetList(body))
      .then((res) => {
        if (res?.payload?.isValidate) {
          firstTimeApiCalledRef.current = true;
          setIsApiCalled(true);
          setReviewMachineLoader(false);
          if (newStateManage?.page === 1) {
            setMachineList(res?.payload?.data?.data?.dataList1);
          } else {
            setMachineList((prev) => [
              ...prev,
              ...res?.payload?.data?.data?.dataList1,
            ]);
          }
          if (res?.payload?.data?.data?.dataList1?.length > 0) {
            setTotalRecord(res?.payload?.data?.recordcount);
          } else {
            setTotalRecord(1);
          }

          setAllMachineList(res?.payload?.data?.data);
          setReviewMachineLoader(false);
          if (
            table &&
            machineList?.length + res?.payload?.data?.data?.dataList1.length <=
              res?.payload?.data?.recordcount
          ) {
            table.addEventListener("scroll", handleScroll);
          } else {
            table.removeEventListener("scroll", handleScroll);
          }
        } else {
          setIsApiCalled(true);
          setMachineList([]);
          setAllMachineList(null);
          setReviewMachineLoader(false);
          setCategoryApiLoader(false);
          setIsSearching(false);
        }
      })
      .finally(() => {
        setLoading(false);
        setReviewMachineLoader(false);
        setCategoryApiLoader(false);
        setIsSearching(false);
      });
  };

  const machineDetailArr = [
    {
      displayName: "Total Machines",
      fieldName: "totalmachines",
      borderColor: "",
      statusColor: "",
    },
    {
      displayName: "Pending",
      fieldName: "totalpending",
      borderColor: "active-status-border pending-machines",
      statusColor: "pending-machines",
    },
    {
      displayName: "In Process",
      fieldName: "totalinprocess",
      borderColor: "active-status-border in-process-machines",
      statusColor: "in-process-machines",
    },
    {
      displayName: "Rejected",
      fieldName: "totalrejected",
      borderColor: "active-status-border rejected-machines",
      statusColor: "rejected-machines",
    },
    {
      displayName: "Approved",
      fieldName: "totalapproved",
      borderColor: "active-status-border approved-machines",
      statusColor: "approved-machines",
    },
  ];
  const handleCardStatusClick = (status) => {
    if (newStateManage.status === status) {
      return;
    } else {
      setReviewMachineLoader(true);
      setActiveStatus(status);
      let a = { ...newStateManage };
      a.page = 1;
      a.status = status;
      setNewStateManage(a);
      setMachineList([]);
    }
  };

  const handleOthersTabModal = (index, categoryId) => {
    if (CategoryID === categoryId) return;
    let a = { ...newStateManage };
    a.page = 1;
    a.catagory = categoryId;
    setNewStateManage(a);
    // setSearchMachine("");
    setMachineList([]);
    setActiveTab(index);
    setCategoryID(categoryId);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleScroll = () => {
    const findTable = document.querySelector(
      "#ReviwerTableContainer .table-responsive"
    );
    let scrollHeight = findTable.scrollHeight;
    let scrollTop = findTable.scrollTop;
    let clientHeight = findTable.clientHeight;
    if (
      scrollHeight < scrollTop + clientHeight + 100 &&
      !loading &&
      machineList?.length <= totalRecord
    ) {
      document
        .querySelector("#ReviwerTableContainer .table-responsive")
        .removeEventListener("scroll", handleScroll);
      let a = { ...newStateManage };
      a.page += 1;
      setNewStateManage(a);
    }
  };

  useEffect(() => {
    getCategoryList();
  }, []);

  useEffect(() => {
    if (machineList?.length < totalRecord) {
      getMachineList();
    }
  }, [newStateManage]);

  useEffect(() => {
    if (firstTimeApiCalledRef.current) {
      let a = { ...newStateManage };
      a.page = 1;
      setNewStateManage(a);
    }
    setMachineList([]);
  }, [debouncingValue]);

  return (
    <div className="dashboard-main market-place-page-main main-dev-dahsboard">
      <div className="all-page-top all-page-top-mchine-review">
        <Container>
          <div className="top-section-all align-items-start">
            <div className="top-section-left">
              <div className="d-flex align-items-center gap-3 mb16">
                <h1 className="mb-0">Dashboard</h1>
              </div>
              <div
                className={`my-machine-top-boxes-wrapper  ${
                  reviewMachineLoader ? "disableClickEvent" : ""
                }`}
              >
                {reviewMachineLoader && !isApiCalled ? (
                  <Loader type={LoaderType.NumberCount} count={5} />
                ) : (
                  machineDetailArr?.map((item) => {
                    const isActive = activeStatus === item.displayName;
                    return (
                      <div
                        key={item.fieldName}
                        className={`my-machine-top-box-single total-machines cursor-pointer ${
                          item?.statusColor
                        } ${isActive ? item?.borderColor : ""}`}
                        onClick={() => handleCardStatusClick(item?.displayName)}
                      >
                        <h4>
                          {allMachineList?.dataList5?.[0]?.[item?.fieldName]
                            ? allMachineList?.dataList5?.[0]?.[item?.fieldName]
                            : 0}
                        </h4>
                        <p>{item?.displayName}</p>
                      </div>
                    );
                  })
                )}
              </div>
            </div>

            <div className="top-section-right">
              <img
                src={toprightimg}
                alt="top-right-img"
                className="top-section-right-img"
              />
            </div>
          </div>
        </Container>
      </div>
      <div className="main-page-content MachineReviewListing-main-page-content">
        <Container className={categoryApiLoader ? "disableClickEvent" : ""}>
          <Tab.Container id="left-tabs-example" defaultActiveKey={"All"}>
            <Col xl={12}>
              <Row className="mb10 ">
                <Col xl={4}>
                  <div className="d-flex align-items-center gap-3 customtab-review">
                    <h2 className="marketplace-detail-right-top-tab-main-title">
                      All Machines
                    </h2>
                    <div className="header-search-input searchplaceholder">
                      <InputGroup>
                        <InputGroup.Text id="basic-addon1">
                          <img
                            src={searchicon}
                            alt="searchicon"
                            className="cursor-pointer"
                          />
                        </InputGroup.Text>
                        <Form.Control
                          placeholder="Search Machines"
                          aria-label="Search"
                          aria-describedby="basic-addon1"
                          value={searchTerm}
                          onChange={handleSearchChange}
                        />
                      </InputGroup>
                    </div>
                  </div>
                </Col>
                <Col xl={4} className="marketplace-detail-right-top-tab-main">
                  <div className="custom-tabing">
                    {LoadingCategory ? (
                      <div className="single-tab">
                        <Skeleton height={15} width={500} />
                      </div>
                    ) : categoryList?.length > 0 ? (
                      <>
                        {categoryList?.map((item, index) => {
                          if (index <= 4) {
                            return (
                              <div
                                key={item?.categoryid}
                                className={
                                  activeTab === index
                                    ? "single-tab active"
                                    : "single-tab"
                                }
                                onClick={() => {
                                  if (
                                    newStateManage?.catagory ===
                                    item?.categoryid
                                  ) {
                                    return;
                                  } else {
                                    setReviewMachineLoader(true);
                                    setActiveTab(index);
                                    setCategoryID(item?.categoryid);
                                    setMachineList([]);
                                    let a = { ...newStateManage };
                                    a.page = 1;
                                    a.catagory = item?.categoryid;
                                    setNewStateManage(a);
                                  }
                                }}
                              >
                                <span>{item.categoryname}</span>
                              </div>
                            );
                          }
                        })}
                        {categoryList?.length > 5 && (
                          <div
                            className={
                              activeTab > 4 ? "single-tab active" : "single-tab"
                            }
                            onClick={(e) => {
                              e.preventDefault();
                              setShowOthersTab(!showOthersTab);
                              handleshowMenu();
                            }}
                            ref={othersTabRef}
                          >
                            <span>Others</span>
                          </div>
                        )}
                      </>
                    ) : (
                      <div className="single-tab">
                        <span>No Data found.</span>
                      </div>
                    )}
                  </div>
                </Col>
                <Col xl={4}></Col>
              </Row>
            </Col>
            <Tab.Content>
              <div
                className="table-wrapper-main tabwrapper-main"
                id="ReviwerTableContainer"
              >
                <Table responsive id="ReviwerTable" ref={tableRef}>
                  <thead>
                    <tr>
                      <th>Type</th>
                      <th>Machine Name</th>
                      <th className="">Version</th>
                      <th className="">Developer</th>
                      <th className="text-center">Submitted Date</th>
                      <th>Reviewing By</th>
                      <th>Category</th>
                      <th>status</th>
                      {/* {MachineStatusRef.current === "Rejected" ||
                      MachineStatusRef.current === "Publish" ? (
                        ""
                      ) : (
                        <th className="text-end sticky-actions">Action</th>
                      )} */}
                      {activeStatus === "Rejected" ||
                      activeStatus === "Approved" ? (
                        ""
                      ) : (
                        <th className="text-end sticky-actions">Action</th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {reviewMachineLoader ? (
                      <Loader
                        type={LoaderType.TableRow}
                        count={10}
                        nooftd={
                          activeStatus === "Rejected" ||
                          activeStatus === "Approved"
                            ? 8
                            : 9
                        }
                      />
                    ) : (
                      <>
                        {!reviewMachineLoader && machineList?.length > 0 ? (
                          machineList.map((item, index) => {
                            let color = "#EB8900";
                            let classNameForMachineType = "greenbage";

                            if (item?.machinestatustype === "Discontinue") {
                              classNameForMachineType = "redbage";
                            }
                            if (item?.machinestatustype === "Deprecated") {
                              classNameForMachineType = "yellowbage";
                            }

                            if (item?.status === "In Process") {
                              color = "#E8C512";
                            }

                            return (
                              <>
                                <tr key={item?.categoryid}>
                                  <td>
                                    <span
                                      className={`${classNameForMachineType}`}
                                    >
                                      {item?.machinestatustype}
                                    </span>
                                  </td>
                                  {/* <td>{item?.machinename}</td> */}
                                  <td title={item?.machinename}>
                                {commonservices.truncateText(item?.machinename, 50)}
                              </td>
                                  <td>{item?.versionnumber}</td>
                                  <td>{item?.subscribername}</td>
                                  <td className="text-center">
                                    {commonservices.convertDateToLocal(
                                      item?.submitteddate
                                    )}
                                  </td>
                                  <td>
                                    <div className="overlapping-imgs">
                                      {item?.profilepicurl ? (
                                        <img
                                          src={item?.profilepicurl}
                                          alt="placeholderuser"
                                          title={item?.reviewbyname}
                                          onError={({ currentTarget }) => {
                                            currentTarget.onerror = null;
                                            currentTarget.src = profilepic;
                                          }}
                                        />
                                      ) : (
                                        <img
                                          src={profilepic}
                                          alt="placeholderuser"
                                        />
                                      )}
                                    </div>
                                  </td>
                                  <td> {item?.categoryname}</td>
                                  <td>
                                    {commonservices.getStatus(item?.status)}
                                    {/* <div className="status-active">
                                    <img
                                      src={
                                        item?.status === "In Process"
                                          ? inprocessstatus
                                          : pendingstatus
                                      }
                                      alt={item?.status}
                                    />
                                    <span
                                      className="fw600"
                                      style={{ color: color }}
                                    >
                                      {item?.status}
                                    </span>
                                  </div> */}
                                  </td>
                                  {activeStatus === "Rejected" ||
                                  activeStatus === "Approved" ? (
                                    ""
                                  ) : (
                                    <td className="sticky-actions">
                                      <div className="all-actions">
                                        <img
                                          src={reviewIcon}
                                          alt="reviewIcon"
                                          onClick={(e) => {
                                            if (item?.status === "Pending") {
                                              navigate(
                                                `/machine-review/${item?.machineid}/${item?.versionnumber}`
                                              );
                                            } else {
                                              if (
                                                Userdata?.userid ===
                                                item?.reviewby
                                              ) {
                                                navigate(
                                                  `/machine-review/${item?.machineid}/${item?.versionnumber}`
                                                );
                                              } else {
                                                takeOverModalRef.current = {
                                                  machineid: item?.machineid,
                                                  machinename:
                                                    item?.machinename,
                                                  versionnumber:
                                                    item?.versionnumber,
                                                  reviewername:
                                                    item?.reviewbyname,
                                                };
                                                setShowTakeOverModal(true);
                                              }
                                            }
                                          }}
                                        />
                                      </div>
                                    </td>
                                  )}
                                </tr>
                              </>
                            );
                          })
                        ) : (
                          <>
                            <tr className="text-center">
                              <td colSpan={9}>
                                <Nodata />
                              </td>
                            </tr>
                          </>
                        )}

                        {loading && (
                          <Loader
                            type={LoaderType.TableRow}
                            count={1}
                            nooftd={
                              activeStatus === "Rejected" ||
                              activeStatus === "Approved"
                                ? 8
                                : 9
                            }
                          />
                        )}
                      </>
                    )}
                  </tbody>
                </Table>
              </div>
            </Tab.Content>
          </Tab.Container>
        </Container>
      </div>
      {showTakeOverModal && (
        <TakeOverReviewModal
          show={showTakeOverModal}
          onHide={(e) => setShowTakeOverModal(false)}
          detail={takeOverModalRef.current}
        />
      )}
      {showOthersTab && (
        <Overlay
          target={othersTabRef.current}
          show={showOthersTab}
          placement="bottom-end"
        >
          {(props) => (
            <Tooltip id="overlay-example" {...props}>
              <CategoryListTab
                handleshowPopup={handleshowMenu}
                categoryList={categoryList}
                handleCategoryClick={handleOthersTabModal}
                selectedCategory={activeTab}
              />
            </Tooltip>
          )}
        </Overlay>
      )}
    </div>
  );
}

export default MachineReviewListing;
